// frontend/src/pages/MatchScoring/conditions.js
//
// "No bowling" / "No keeping" (SB, 30 Oct + 2 Nov 2026 — every match): a
// player who gave that condition with his availability for this match can
// still be picked if the captain insists, but the scorer is warned first and
// the decision is recorded (POST /scorer/matches/:id/condition-override).
//
// Returns true to go ahead, false to choose someone else.
import api from '../../utils/api';

export async function confirmCondition({ matchId, memberId, kind, name, inningsId, overNumber, conditionsById }) {
  const c = conditionsById?.get(memberId);
  const flagged = kind === 'bowling' ? c?.no_bowling : c?.no_keeping;
  if (!flagged) return true;
  const what = kind === 'bowling' ? 'No bowling' : 'No keeping';
  const act  = kind === 'bowling' ? 'bowling him' : 'making him keep wickets';
  const ok = window.confirm(
    `⚠ ${what}\n\n${name || 'This player'} said "${what}" when he gave his availability for this match.\n\nIs the captain still ${act}?`
  );
  if (!ok) return false;
  try {
    await api.post(`/scorer/matches/${matchId}/condition-override`, {
      member_id: memberId, kind, innings_id: inningsId || null,
      over_number: Number.isInteger(overNumber) ? overNumber : null,
    });
  } catch { /* the pick still goes ahead; the record is best-effort */ }
  return true;
}
